<template>
  <v-layout>
    <v-flex>
      <v-data-table
        class="elevation-5"
        :headers="headers"
        :items="items"
        :loading="loadingItems"
        no-data-text="No hay Matching Items que mostrar"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="itemsTotal"
      >
        <template #items="props">
          <tr @click="props.expanded = !props.expanded">
            <td class="blue-grey--text subheading font-weight-light">{{props.item.brand}}</td>
            <td class="text-xs-center">
              <v-items-table-image :item="props.item" />
            </td>
            <td class="blue-grey--text subheading">{{props.item.name}}</td>
            <td class="text-xs-center">
              <v-icon v-if="props.item.hasFeature" color="green">check</v-icon>
              <v-icon v-else color="red">clear</v-icon>
            </td>
            <td class="text-xs-center">
              <v-btn :disabled="!props.item.url" :href="props.item.url" icon target="_blank">
                <v-icon color="blue-grey">open_in_new</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-center">
              <v-btn :disabled="!props.item.description" icon>
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <!-- An expandable slot to show the description of the item -->
        <template #expand="{ item }">
          <v-container v-if="item.description" class="item-description-container">
            <v-layout>
              <v-flex v-html="item.description.html" />
            </v-layout>
          </v-container>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";
import VItemsTableImage from "./ItemsTableImage";

export default {
  components: {
    VItemsTableImage
  },
  data: () => ({
    isTheFirstPaginationMutation: true, // See pagination.set() function
    rowsPerPageItems: [5, 15, 30, 50, 100, 300, 500]
  }),
  computed: {
    ...mapState("featureRules", [
      "feature",
      "items",
      "itemsPagination",
      "itemsTotal",
      "loadingItems"
    ]),
    headers() {
      return [
        {
          text: "Marca",
          value: "brand",
          align: "left",
          sortable: true
        },
        {
          text: "Imagen",
          align: "center",
          sortable: false
        },
        {
          text: "Nombre",
          value: "name",
          align: "left",
          sortable: true
        },
        {
          text: `Tiene "${this.feature.name}"`,
          align: "center",
          sortable: false
        },
        {
          text: "Link",
          align: "center",
          sortable: false
        },
        {
          text: "Descripción",
          align: "center",
          sortable: false
        }
      ];
    },
    /**
     * As the pagination is a property with sync, inmediately after the creation it sets the pagination
     * object in the store, and this trigger the getItems action. So, to avoid getting the items without
     * a direct intention of a search we have this flag `isTheFisrtPaginationMutation` to not get the items
     * with the first pagination mutation.
     */
    pagination: {
      get() {
        return this.itemsPagination;
      },
      set(pagination) {
        let getItems = true;
        if (this.isTheFirstPaginationMutation) {
          this.isTheFirstPaginationMutation = false;
          getItems = false;
        }
        this.setItemsPagination({ pagination, getItems });
      }
    }
  },
  methods: {
    ...mapActions("featureRules", ["setItemsPagination"])
  }
};
</script>

<style scoped>
.item-description-container {
  max-width: 65vw;
  max-height: 50vh;
  overflow: auto;
}
</style>